// @ts-check
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./componentes/Login2/Login";
import Main from "./componentes/Main3/Main";
import Local from "./componentes/Local/index";
import Externo from "./componentes/Externo/Externo";
import { IsAuth } from "./appfunciones";
import Imgupload from "./pages/imgupload/page";
import Caducado from "./componentes/Externo/Caducado";

/**
 *
 * @param {any} props
 * @returns {JSX.Element}
 */
const PrivateRoute = (props) => {
  return IsAuth() ? props.children : <Navigate to="/login" />;
};

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Root />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/main"
          element={
            <PrivateRoute>
              <Main />
            </PrivateRoute>
          }
        />
        <Route
          path="/visor/:id"
          element={
            <PrivateRoute>
              <Local />
            </PrivateRoute>
          }
        />
        <Route path="/imgupload" element={<Imgupload />} />
        <Route path="/externo/:token" element={<Externo />} />
        <Route path="/test" element={<Caducado />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;

const Root = () => {
  return IsAuth() ? <Navigate to="/main" /> : <Navigate to="/login" />;
};
